<template>
  <el-dialog
    title="查看仓库信息"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="900px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      status-icon
      ref="form"
      label-position="right"
      label-width="100px"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="仓库名称" prop="WarehouseName">
            <div class="text" :title="form.WarehouseName">
              {{ form.WarehouseName }}
            </div>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
                    <el-form-item label="仓库编号" prop="WarehouseCode">
                        <div class="text" :title="form.WarehouseCode">
                            {{ form.WarehouseCode }}
                        </div>
                    </el-form-item>
                </el-col> -->
        <el-col :span="12">
          <el-form-item label="仓库类型" prop="WarehouseTypeName">
            <div class="text" :title="form.WarehouseType">
              {{ form.WarehouseTypeName }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="总空间" prop="TotalSpace">
            <div class="text" :title="form.TotalSpace">
              {{ form.TotalSpace }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="管理员" prop="Manager">
            <div class="text" :title="form.Manager">
              {{ form.Manager }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="存储单位" prop="StorageUnit">
            <div class="text" :title="form.StorageUnit">
              {{ form.StorageUnit }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="Remark">
            <div class="text" :title="form.Remark">
              {{ form.Remark }}
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
    
<script>
export default {
  props: ["item"],
  components: {},
  data() {
    return {
      visible: false,
      loading: false,
      isable: true,
      isEdit: false,
      form: {},
    };
  },
  computed: {},
  watch: {
    item: {
      handler: function (v) {
        if (v.WarehouseId) {
          this.isEdit = true;
          this.$get("WareHouse/GetModel", {
            WarehouseId: v.WarehouseId,
          }).then((r) => {
            this.init({ ...r.Result });
          });
        } else {
          this.init({});
          this.isEdit = false;
        }
        this.visible = true;
      },
    },
  },
  methods: {
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
  },
};
</script>
